import { useEffect, useState } from "react";
import { adminApi } from "@/admin/AdminAuthContext";

/**
 * Owns all Admin-User CRUD state and API calls for the Admin Users
 * page -- mirrors useAdminBlogPosts.js's pattern of separating business
 * logic from UI rendering.
 */
export const useAdminUsersList = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [creating, setCreating] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () =>
    Promise.all([adminApi.get("/users"), adminApi.get("/roles")])
      .then(([u, r]) => {
        setUsers(u.data);
        setRoles(r.data);
      })
      .finally(() => setLoading(false));

  useEffect(() => {
    load();
  }, []);

  const assignableRoles = roles.filter((r) => r.key !== "owner");

  const openNew = () => setCreating({ email: "", full_name: "", role_key: assignableRoles[0]?.key || "", password: "" });
  const close = () => setCreating(null);

  const save = async (e) => {
    e.preventDefault();
    await adminApi.post("/users", creating);
    close();
    load();
  };

  const deactivate = async (id) => {
    if (!window.confirm("Deactivate this user?")) return;
    await adminApi.patch(`/users/${id}/deactivate`);
    load();
  };

  const updateCreatingField = (field, value) => setCreating((prev) => ({ ...prev, [field]: value }));

  return { users, roles, assignableRoles, creating, loading, openNew, close, save, deactivate, updateCreatingField };
};
